import { render, staticRenderFns } from "./StackScreen.vue?vue&type=template&id=62762fa9"
import script from "./StackScreen.vue?vue&type=script&lang=js"
export * from "./StackScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports